import * as React from 'react'
import { TextFieldProps } from 'cs-kevlar-react/lib/es/TextField'
import { TextFieldWithFullscreen } from './TextFieldWithFullscreen'

type JsonInputProps = TextFieldProps & {
  json: any | null
}

export const JsonInput: React.FunctionComponent<JsonInputProps> = ({
  json,
  ...rest
}) => {
  const safeJson = json ? json : ''
  return (
    <TextFieldWithFullscreen
      value={JSON.stringify(safeJson, null, 4)}
      multiline
      fullWidth
      {...rest}
    />
  )
}
